import { z } from "zod";

/**
 * A field error as TanStack Form surfaces it.
 *
 * Two shapes reach the same render path: a bare string, when a handler sets the
 * error itself, and a Zod issue object, when the field's schema rejected the
 * value. Parsing both here means each form does not re-decide what an "error"
 * looks like — which is how one of them ended up rendering `[object Object]`.
 */
export const fieldErrorSchema = z.union([
  z.string(),
  z.object({ message: z.string() }).transform((issue) => issue.message),
]);
